import { Cloud, Star } from "lucide-react";

interface PageBackgroundProps {
  children: React.ReactNode;
  className?: string;
}

const PageBackground = ({ children, className = "" }: PageBackgroundProps) => {
  return (
    <div className={`min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 relative overflow-hidden ${className}`}>
      {/* Static Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Stars */}
        <div className="absolute top-20 left-[10%] text-amber-400/50">
          <Star className="w-6 h-6" />
        </div>
        <div className="absolute top-40 right-[15%] text-amber-400/50">
          <Star className="w-8 h-8" />
        </div>
        <div className="absolute top-[60%] left-[5%] text-amber-400/50">
          <Star className="w-5 h-5" />
        </div>
        <div className="absolute top-[30%] right-[8%] text-amber-400/50">
          <Star className="w-4 h-4" />
        </div>
        <div className="absolute bottom-[30%] right-[25%] text-amber-400/50">
          <Star className="w-5 h-5" />
        </div>
        <div className="absolute top-[70%] left-[30%] text-amber-400/50">
          <Star className="w-4 h-4" />
        </div>
        <div className="absolute top-[15%] left-[45%] text-amber-400/50">
          <Star className="w-5 h-5" />
        </div>
        
        {/* Clouds */}
        <div className="absolute top-32 left-[20%] text-amber-400/20">
          <Cloud className="w-16 h-16" />
        </div>
        <div className="absolute top-[50%] right-[10%] text-amber-400/20">
          <Cloud className="w-20 h-20" />
        </div>
        <div className="absolute bottom-40 left-[8%] text-amber-400/20">
          <Cloud className="w-12 h-12" />
        </div>
        <div className="absolute top-[25%] right-[35%] text-amber-400/20">
          <Cloud className="w-14 h-14" />
        </div>
        <div className="absolute bottom-[20%] right-[15%] text-amber-400/20">
          <Cloud className="w-16 h-16" />
        </div>
        <div className="absolute top-[65%] left-[40%] text-amber-400/20">
          <Cloud className="w-18 h-18" />
        </div>
        <div className="absolute top-[10%] left-[5%] text-amber-400/20">
          <Cloud className="w-14 h-14" />
        </div>
        <div className="absolute bottom-[50%] left-[55%] text-amber-400/20">
          <Cloud className="w-15 h-15" />
        </div>
      </div>
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default PageBackground;
